import { selectActiveFeature } from '../../../Map/selectors';
import { IMapSelection } from '../../../Map/types/mapSelection';
import { TThunkAction } from '../../types/redux';
import { setMapSelection } from '../mapSelection/mapSelection';
import { updateFeatureProperties } from '../updateFeatureProperties/updateFeatureProperies';

export function setMapOffer(selection: IMapSelection): TThunkAction {
  return (dispatch, getState) => {
    const { realtyId, feature } = selection;

    if (!feature.properties.offers.some(offer => offer.realtyId === realtyId)) {
      return;
    }

    const activeFeature = selectActiveFeature(getState());
    // При листании пагинации выбранный пин остаётся тем же - гасить его не нужно.
    const isSameFeature = activeFeature?.id === feature.id && activeFeature.precision === feature.precision;

    dispatch(setMapSelection(selection));

    if (activeFeature && !isSameFeature) {
      dispatch(
        updateFeatureProperties({
          featureId: activeFeature.id,
          precision: activeFeature.precision,
          properties: { isActive: false },
        }),
      );
    }
    dispatch(
      updateFeatureProperties({ featureId: feature.id, precision: feature.precision, properties: { isActive: true } }),
    );
  };
}
